import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Input, Avatar, Modal, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "antd/dist/reset.css";
import { format } from "date-fns";

const { Title } = Typography;

const API_URL =
  "https://portaltransaccionalback.azurewebsites.net/api/ObtenerRegistrosEventos/ForoCalidad";

const EventosTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchColumns, setSearchColumns] = useState({});

  useEffect(() => {
    axios
      .get(API_URL)
      .then((response) => {
        const updatedData = response.data.map((item) => ({
          ...item,
          estadoPago: item.estadoPago ? item.estadoPago : "Pendiente",
          fechaInscripcion: item.fechaInscripcion
            ? format(new Date(item.fechaInscripcion), "dd/MM/yyyy HH:mm:ss")
            : "Fecha no disponible",
          fechaPago: item.fechaPago
            ? format(new Date(item.fechaInscripcion), "dd/MM/yyyy HH:mm:ss")
            : "Fecha no disponible",
        }));

        setData(updatedData);
        setFilteredData(updatedData);
      })
      .catch((error) => console.error("Error al obtener los datos: ", error))
      .finally(() => setLoading(false));
  }, []);

  // Búsqueda general en toda la tabla
  const handleGlobalSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    setFilteredData(
      data.filter((item) =>
        Object.values(item).some((val) => String(val).toLowerCase().includes(value))
      )
    );
  };

  // Búsqueda por columna específica
  const handleColumnSearch = (e, dataIndex) => {
    const value = e.target.value.toLowerCase();
    setSearchColumns({ ...searchColumns, [dataIndex]: value });

    const filtered = data.filter((item) => {
      return Object.entries(searchColumns).every(([key, searchValue]) => {
        return String(item[key] || "")
          .toLowerCase()
          .includes(searchValue);
      });
    });

    setFilteredData(filtered);
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setVisible(true);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: () => (
      <Input
        placeholder={`Buscar ${dataIndex}`}
        value={searchColumns[dataIndex] || ""}
        onChange={(e) => handleColumnSearch(e, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: "block" }}
      />
    ),
    filterIcon: () => (
      <SearchOutlined style={{ color: searchColumns[dataIndex] ? "#1890ff" : undefined }} />
    ),
  });

  const columns = [
    {
      title: "Imagen",
      dataIndex: "adjunto",
      key: "adjunto",
      render: (text, record) =>
        text ? (
          <Avatar
            src={text}
            alt={record.nombre}
            onClick={() => handleImageClick(text)}
            style={{ cursor: "pointer" }}
          />
        ) : (
          <Avatar>{record.nombre ? record.nombre.charAt(0) : "?"}</Avatar>
        ),
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      ...getColumnSearchProps("nombre"),
    },
    {
      title: "Correo",
      dataIndex: "correo",
      key: "correo",
      ...getColumnSearchProps("correo"),
    },
    {
      title: "Documento",
      dataIndex: "numeroIdentificacion",
      key: "numeroIdentificacion",
      ...getColumnSearchProps("numeroIdentificacion"),
    },
    {
      title: "Evento",
      dataIndex: "evento",
      key: "evento",
      ...getColumnSearchProps("evento"),
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      sorter: (a, b) => a.valor - b.valor,
    },
    {
      title: "Fecha Inscripción",
      dataIndex: "fechaInscripcion",
      key: "fechaInscripcion",
      sorter: (a, b) => new Date(a.fechaInscripcion) - new Date(b.fechaInscripcion),
      render: (text) => text || "No disponible",
    },
    {
      title: "Estado del pago",
      dataIndex: "estadoPago",
      key: "estadoPago",
      filters: [
        { text: "Rechazado", value: "Rechazado" },
        { text: "Aprobado", value: "Aprobado" },
        { text: "Pendiente", value: "Pendiente" },
      ],
      onFilter: (value, record) => record.estadoPago === value,
    },
    {
      title: "Fecha Pago",
      dataIndex: "fechaPago",
      key: "fechaPago",
      sorter: (a, b) => new Date(a.fechaPago) - new Date(b.fechaPago),
      render: (text) => text || "No disponible",
    },
    {
      title: "ID GRUPO",
      dataIndex: "grupoId",
      key: "grupoId",
      sorter: (a, b) => a.grupoId.localeCompare(b.grupoId),
      ...getColumnSearchProps("grupoId"),
    },
  ];

  return (
    <div style={{ padding: 90 }}>
      <Title level={2} style={{ textAlign: "center", color: "#1890ff" }}>
        Personas Inscritas
      </Title>
      <Input
        placeholder="Buscar en toda la tabla"
        prefix={<SearchOutlined />}
        value={searchText}
        onChange={handleGlobalSearch}
        style={{ marginBottom: 16, width: "100%" }}
      />
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey={(record) => record.id || record.numeroIdentificacion}
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }} // Permite scroll horizontal
      />

      <Modal open={visible} footer={null} onCancel={() => setVisible(false)}>
        <img src={selectedImage} alt="Vista previa" style={{ width: "100%" }} />
      </Modal>
    </div>
  );
};

export default EventosTable;
